<template>
    <form>
      <b-field grouped>
        <b-field label="Trailer" expanded>
          <b-select expanded v-model="equipment.companyJobTrailerType" >
            <option v-for="equipment in equipmentList" :value="equipment" :key="equipment"> {{ equipment }}</option>
          </b-select>
        </b-field>

        <b-field label="Straps" expanded>
          <b-input placeholder="number of straps" v-model.number="equipment.companyJobStrapCount"/>
        </b-field>

        <b-field label="Insurance" expanded>
          <b-input placeholder="minimum insurance" v-model.number="equipment.companyJobInsuranceCoverageMinimum" icon="dollar-sign" />
        </b-field>
      </b-field>

      <b-field label="Comments">
        <b-input type="textarea" placeholder="Commnets on equipment needs. i.e.: if refrigerated specify the temperature or if you have special handling intructions." v-model="equipment.companyJobEquipmentComments" />
      </b-field>


    </form>
</template>

<script>
import equipmentList from '@/lookup-data/equipment-list'
import { isEqual } from 'lodash-es'
export default {
  name: 'EquipmentInformation',

  props: {
    value: {
      type: Object
    }
  },

  created() {
    this.equipment = Object.assign({}, this.value)
  },

  data() {
    return {
      equipmentList,
      equipment: {
        companyJobTrailerType: '',
        companyJobStrapCount: null,
        companyJobInsuranceCoverageMinimum: null,
        companyJobEquipmentComments: ''
      }
    }
  },

  methods: {
    notify() {
      this.$emit('input', this.equipment)
    }
  },

  watch: {
    value: {
      deep: true,
      handler() {
        if (!isEqual(this.equipment, this.value)) {
          this.equipment = Object.assign({}, this.value)
        }
      }
    },

    equipment: {
      deep: true,
      handler: 'notify'
    }
  }
}
</script>

<style scoped>
</style>
